import React, { useState } from 'react'
import useOnScreenCallbacks from './useOnScreenCallbacks'

/**
 * Hooks that return true if element was at least once shown in viewport.
 */
export default function useOnScreenWithMemory(ref: React.RefObject<Element | null>, rootMargin = '0px') {
  const [wasIntersecting, setWasIntersecting] = useState(false)

  useOnScreenCallbacks(
    () => setWasIntersecting(true),
    () => {},
    ref,
    rootMargin,
  )
  return wasIntersecting
}
